import './hassles.component.scss'
// import './hassles.component.pug'
import { Application } from '../../helpers/app'

Application.swiper().then(({ Swiper, Navigation }) => {
  Swiper.use([Navigation])
  new Swiper('.hassles-slider', {
    slidesPerView: 1,
    effect: 'fade',
    loop: true,
    fadeEffect: {
      crossFade: true
    },
    autoHeight: true,
    navigation: {
      prevEl: '.hassles-nav[data-nav-prev]',
      nextEl: '.hassles-nav[data-nav-next]'
    }
  })
  Application.lozad('.hassles-slider .lozad')
})
